import * as XLSX from 'xlsx';
import React from 'react';
import FileInput from 'components/shared/FileInput';

/*
 * Simple HTML5 file drag-and-drop wrapper
 * usage: <ImportXSLXFile handleWorkbook={handleWorkbook} />
 *   handleFile(workbook:XSLXWorkbook):void;
 */
export default class ImportXSLXFile extends React.Component {
  constructor(props) {
    super(props);
    this.handleFile = this.handleFile.bind(this);
  }

  handleFile(file) {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });
      this.props.handleWorkbook(wb);
    };
    if (rABS) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  }

  render() {
    return (
      <FileInput
        id={this.props.id}
        handleFile={this.handleFile}
        label={this.props.label}
        accept={SheetJSFT}
      />
    );
  }
}

/* list of supported file types */
const SheetJSFT = [
  'xlsx',
  'xlsb',
  'xlsm',
  'xls',
  'xml',
  'csv',
  'txt',
  'ods',
  'fods',
  'uos',
  'sylk',
  'dif',
  'dbf',
  'prn',
  'qpw',
  '123',
  'wb*',
  'wq*',
  'html',
  'htm',
]
  .map((x) => '.' + x)
  .join(',');

/*
 * Simple HTML Table
 * usage: <OutTable data={data} cols={cols} />
 *   data:Array<Array<any> >;
 *   cols:Array<{name:string, key:number|string}>;
 */
export class OutTable extends React.Component {
  render() {
    return (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              {this.props.cols.map((c) => (
                <th key={c.key}>{c.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.props.data.map((r, i) => (
              <tr key={i}>
                {this.props.cols.map((c) => (
                  <td key={c.key}>{r[c.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
